import { action } from 'typesafe-actions'
import { PosthogActions, TFeatureFlags, TFlagsPayload } from './types'

export const setFeatureFlags = (payload: { flags: TFeatureFlags[]; payloads: TFlagsPayload }) =>
  action(PosthogActions.SET_FEATURE_FLAGS, payload)

export const clearFeatureFlags = () => action(PosthogActions.CLEAR_FEATURE_FLAGS)

export type TAction = ReturnType<typeof setFeatureFlags> | ReturnType<typeof clearFeatureFlags>
